import React from 'react';
import { Input } from '../Input';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  controlClassName?: string;
  icon?: React.ReactNode;
  iconClassName?: string;
}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(({
  type = 'text',
  ...props
}, ref) => (
  <Input
    ref={ref}
    type={type}
    {...props}
  />
));

TextInput.displayName = 'TextInput';

export { TextInput };
